module.exports = __webpack_public_path__ + "assets/img/partner-program-bj.75638c71.png";